import { Component } from 'react'
import { connect } from 'react-redux'
import { TrackingHOC } from 'hocs'
import {
  selectCurrentPhone,
  selectShowCallHandler,
  selectQuery,
  selectLocation
} from '../App/selectors'
import { selectIsStarted } from '../CallHandler/selectors'
import Header from 'components/Header'
import { updatePhoneId } from '../App/actions'
import { OptionsHOC } from '../../hocs'
import get from 'lodash/get'
import { createGlobalStyle } from 'styled-components'

// Use top-level variable to preserve value upon navigation
let showHeader = true

class HeaderContainer extends Component {
  constructor(props) {
    super(props)

    if (get(props.query, 'showHeader') === 'false') {
      showHeader = false
    }
  }

  handleHomeClick = () => {
    this.props.createEvent({
      category: 'navigation',
      data: { link_to: '/', source: 'HeaderHome' }
    })

    this.props.updatePhoneId(null)
  }

  render() {
    const props = {
      ...this.props,
      handleHomeClick: this.handleHomeClick,
      showNotes: this.props.getOption('showNotes')
    }

    if (!showHeader) {
      // Enable responsiviness
      createGlobalStyle`.container { min-width: auto !important }`
      // Return empty div to serve as padding
      return <div style={{ height: '20px' }} />
    }

    return <Header {...props} />
  }
}

const mapStateToProps = (state) => ({
  currentPhone: selectCurrentPhone(state),
  showCallHandler: selectShowCallHandler(state),
  isStarted: selectIsStarted(state),
  query: selectQuery(state),
  location: selectLocation(state)
})

const mapDispatchToProps = (dispatch) => ({
  updatePhoneId: (phoneId) => dispatch(updatePhoneId(phoneId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsHOC(TrackingHOC(HeaderContainer)))
